<template>
  <div class="mb-3">
    <b for="name" v-if="label" class="form-label"> {{ label }} </b>
    <VueDatePicker v-model="internalTime" :enable-time="true" :enable-seconds="false" :time-picker="true"
      :format="timeFormat" :hour-step="1" :minute-step="1" :second-step="1" placeholder="Select time" />
  </div>
</template>

<script>
import { ref, watch, computed } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  name: 'TimePicker',
  components: {
    VueDatePicker,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: { type: String },
  },
  setup(props, { emit }) {
    // Internal reactive value to hold the selected time object
    const internalTime = ref(null);

    // Watch for changes to modelValue and update internalTime
    watch(
      () => props.modelValue,
      (newValue) => {
        if (newValue) {
          const [hours, minutes] = newValue.split(':');
          internalTime.value = { hours: parseInt(hours), minutes: parseInt(minutes), seconds: 0 };
        }
      },
      { immediate: true }
    );

    // Emit the string formatted time when internalTime changes
    watch(internalTime, (newValue) => {
      if (newValue) {
        const timeString = `${String(newValue.hours).padStart(2, '0')}:${String(newValue.minutes).padStart(2, '0')}`;
        emit('update:modelValue', timeString); // Emit the string value to parent
      }
    });

    const timeFormat = 'HH:mm'; // Format for hours and minutes

    return {
      internalTime,
      timeFormat,
    };
  },
};
</script>

<style scoped>
/* Add custom styles if needed */
</style>
